import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button, Card, List, Typography } from 'antd';
import { PlusOutlined, ExclamationCircleTwoTone } from '@ant-design/icons';
import { useStores } from '@app/hooks/stores';
import { SubTenantInterface, TenantInterface } from '@app/modules/Tenants/Tenant.interfaces';
import SubTenantItem from '@app/modules/Tenants/components/SubTenantItem';
import { Can } from '@app/modules/Auth';

declare type SubTenantsListProps = {
  tenant?: TenantInterface;
};

const SubTenantsList: React.FC<SubTenantsListProps> = () => {
  const { tenantsStore } = useStores();

  const { selectedTenant, subTenantsMap, subTenantsLoading, getSubTenants, addBlankSubTenant } = tenantsStore;

  useEffect(() => {
    if (selectedTenant && !subTenantsMap[selectedTenant.id]) {
      getSubTenants(selectedTenant.id);
    }
  }, [selectedTenant, selectedTenant && subTenantsMap[selectedTenant.id]?.length]);

  const addBlankItem = () => {
    addBlankSubTenant(selectedTenant?.id);
  };

  return (
    <Card
      title="Subtenants"
      className="table-card"
      extra={
        <Can
          action="post:subtenants"
          yes={() => (
            <Button type="link" icon={<PlusOutlined />} onClick={addBlankItem} disabled={!selectedTenant}>
              Add
            </Button>
          )}
          no={() => null}
        />
      }
    >
      {selectedTenant && (
        <List
          loading={subTenantsLoading}
          itemLayout="vertical"
          size="large"
          pagination={false}
          dataSource={subTenantsMap[selectedTenant.id]}
          renderItem={(item: SubTenantInterface) => <SubTenantItem item={item} />}
        />
      )}
      {!selectedTenant && (
        <Typography.Paragraph style={{ textAlign: 'center', marginTop: '10px' }}>
          <ExclamationCircleTwoTone style={{ fontSize: '24px' }} />
          <Typography.Title level={5}>Please select tenant</Typography.Title>
        </Typography.Paragraph>
      )}
    </Card>
  );
};

export default observer(SubTenantsList);
